const makePairsInPagesArray = initialArray => {
  // Функция возвращает первым элементом массив из первой страницы книги (обложки)
  // Остальные страницы будут сгруппированы по парам
  // В конце будет массив либо из одной страницы, либо из двух
  const initialArrayWithoutFirstItem = initialArray.slice(1);
  const modifiedArray = initialArrayWithoutFirstItem.reduce(function (
    result,
    _,
    index,
    array,
  ) {
    if (index % 2 === 0) result.push(array.slice(index, index + 2));
    return result;
  },
  []);
  return [[initialArray[0]], ...modifiedArray];
};

export default makePairsInPagesArray;
